import i18next from 'i18next';
import { func, shape, string, object, number, boolean } from 'prop-types';
import React from 'react';

import { CODE_COUNTRY } from '~constants/environment';
import { CLIENT_PAGES } from '~constants/pages';
import Text from '~components/Text';
import ErrorMessage from '~components/ErrorMessage';

import { FIELDS } from '../../constants';
import styles from '../../styles.module.scss';
import LoginInput from '../LoginInput';

function FinishRegisterForm({
  setFieldValue,
  values,
  errors,
  avoidErrorUntilSubmit,
  submitCount,
  apiErrors
}) {
  const handleChange = (e) => setFieldValue(e.target.name, e.target.value);
  const navigateToTermsAndConditions = () => window.open(CLIENT_PAGES.TERMS_AND_CONDITIONS.path);
  return (
    <div className="column">
      <LoginInput
        name={FIELDS.NAME}
        label={i18next.t('Login:name')}
        value={values[FIELDS.NAME]}
        onChange={handleChange}
      />
      <LoginInput
        name={FIELDS.PHONE}
        type="tel"
        label={i18next.t('Login:phone')}
        containerStyle="m-top-6"
        value={values[FIELDS.PHONE]}
        prefix={CODE_COUNTRY}
        onChange={handleChange}
      />
      {(avoidErrorUntilSubmit || submitCount > 0) && Object.keys(errors).length > 0 && (
        <div className={styles.error}>
          <ErrorMessage message={i18next.t('Login:error')} />
        </div>
      )}
      {apiErrors && apiErrors.map((el) => <ErrorMessage key={el} message={el} />)}
      <button type="submit" className={`full-width text-uppercase bold m-top-6 ${styles.button}`}>
        {i18next.t('Login:start')}
      </button>
      <div className="text-center m-top-5">
        <Text className={`light text-light ${styles.text}`}>{i18next.t('Login:acceptanceText')}</Text>
        <button
          type="button"
          onClick={navigateToTermsAndConditions}
          className={`m-right-1 link ${styles.terms}`}>
          {i18next.t('Login:termsAndConditions')}
        </button>
        <Text className={`light text-light ${styles.text}`}>{i18next.t('Login:endingText')}</Text>
      </div>
    </div>
  );
}

FinishRegisterForm.propTypes = {
  setFieldValue: func.isRequired,
  apiErrors: shape({
    // eslint-disable-next-line camelcase
    phone_taken: string
  }),
  avoidErrorUntilSubmit: boolean,
  // eslint-disable-next-line react/forbid-prop-types
  errors: object,
  submitCount: number,
  values: shape({
    [FIELDS.EMAIL]: string
  })
};

export default FinishRegisterForm;
